import React, { useState } from 'react';
import clsx from 'clsx';
import IconClose from '../utils/icon/icon-close.svg';
import { useProduct } from './product-context';

const ProductCustomTextBanner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { product } = useProduct();

  function unescapeHTML(html, removeContainer = false) {
    const escapeEl = document.createElement('textarea');
    escapeEl.innerHTML = html;
    if (removeContainer) {
      const unwrapEl = document.createElement('div');
      unwrapEl.innerHTML = escapeEl.textContent;
      return unwrapEl.firstChild?.innerHTML;
    }
    return escapeEl.textContent;
  }

  if (!product?.metafields?.promoTitle) {
    return null;
  }

  const title = unescapeHTML(product?.metafields?.promoTitle);
  const content = unescapeHTML(product?.metafields?.promoMessage, true);
  const bgColor = product?.promo?.promoBackground || '#FFF0E5';
  const textColor = product?.promo?.promoText || '#000000';
  return (
    <>
      <div
        className={clsx('custom-promo relative rounded-md', {
          'px-5 py-4': isOpen,
          'px-2 py-0.5': !isOpen,
        })}
        style={{ backgroundColor: bgColor, color: textColor }}
      >
        <h3
          className={clsx('body-3-bold text-center', {
            'sr-only': isOpen,
          })}
        >
          <button
            aria-expanded={isOpen}
            aria-controls="banner-content"
            className="rte mx-auto block text-center [&_a]:text-inherit [&_p]:m-0"
            onClick={() => setIsOpen((value) => !value)}
            dangerouslySetInnerHTML={{ __html: title }}
          ></button>
        </h3>
        <div
          className={clsx('body-3', {
            hidden: !isOpen,
          })}
          id="banner-content"
        >
          <div
            className="rte [&>:first-child]:mt-0 [&>:last-child]:mb-0 [&>ul]:m-0 [&>ul]:px-2 [&_a]:text-inherit"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
          <button
            aria-expanded={isOpen}
            aria-controls="banner-content"
            aria-label={window?.TMW?.Strings?.accesssibility?.close}
            className="absolute right-2.5 top-2.5 [&>svg]:size-3"
            onClick={() => setIsOpen((value) => !value)}
          >
            <IconClose />
          </button>
        </div>
      </div>
    </>
  );
};

export default ProductCustomTextBanner;
